import gql from 'graphql-tag';

type Filters = {
  placesNameFilter: string;
  placesCityFilter: string;
  placesStateFilter: string;
};

const GET_FILTER_VALUES = gql`
  {
    placesNameFilter @client
    placesCityFilter @client
    placesStateFilter @client
  }
`;

export { GET_FILTER_VALUES, Filters };
